import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Observable, Subject } from 'rxjs';
import { AuthService } from './auth.service';
import { LocalStorageService } from 'ngx-webstorage';
import { environment } from '../../../environments/environment';
import { DestroyComponent } from '../destroy-component/destroy-component';

@Injectable({
  providedIn: 'root'
})
export class IdleService extends DestroyComponent{
  private idleState = new Subject<string>();
  private timedOut = new Subject<boolean>();
  private lastPing = new Subject<Date>();

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private authService: AuthService,
    private localStorage: LocalStorageService
  ) {
    super();
    // 5 minutes
    idle.setIdle(300);
    // 30 seconds
    idle.setTimeout(30);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState.next('');
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState.next('Timed out!');
      this.timedOut.next(true);
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState.next('You\'ve gone idle!');
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState.next(`(${countdown})`);
      if (countdown === 30) {
        this.idle.clearInterrupts();
      }
    });

    keepalive.interval(15);
    keepalive.onPing.subscribe(() => this.lastPing.next(new Date()));
  }

  startWatching(): void {
    this.idle.watch();
  }

  stopWatching(): void {
    this.idle.stop();
  }

  stay(): void {
    this.reset();
  }

  logout(errorMessage?: string): void {
    this.authService.logout().subscribe(
      success => {
        if (success.successFlag) {
          this.localStorage.clear();
          window.location.assign(environment.logoutUrl);
        } else if (errorMessage) {
          window.location.href = `${environment.logoutUrl}?error=${encodeURIComponent(errorMessage)}`;
        } else {
          console.error('Logout failed:', success.errorMsg);
          this.localStorage.clear();
          window.location.assign(environment.logoutUrl);
        }
      },
      error => {
        console.error('Logout request failed', error);
        this.localStorage.clear();
        window.location.assign(environment.logoutUrl);
      });
  }

  getIdleState(): Observable<string> {
    return this.idleState.asObservable();
  }

  getTimedOut(): Observable<boolean> {
    return this.timedOut.asObservable();
  }

  private reset(): void {
    this.idle.watch();
    this.idleState.next('Started.');
    this.timedOut.next(false);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
  }
}
